import React from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import CreateAncmtModal from "components/announcements/CreateAncmtModal";
import { setViewCreateAncmtModal } from "features/anouncements/announcementSlice";
import AnnouncementFeed from "components/announcements/AnnouncementFeed";
import CreateButton from "components/buttons/CreateButton";
import { ComponentPageWrapper } from "pages/pages.styled";
import { MobilePageTitle } from "components/main.styled";

import SectionHelp from "components/help/SectionHelp";
import { useTranslation } from "react-i18next";

export default function Anouncements() {
  const { t: translate } = useTranslation();
  const { user, admin } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const { showCreateAnnouncementModal } = useSelector(
    (state) => state.announcement,
  );
  const { profileChurch } = useSelector((state) => state.profileChurch);

  const handleCreateAnouncement = () => {
    dispatch(setViewCreateAncmtModal());
  };

  return (
    <ComponentPageWrapper>
      <MobilePageTitle>
        {translate("web:general.announcements")}
      </MobilePageTitle>
      {(user.isOrganization || admin[profileChurch._id]) && (
        <TopWrap>
          <CreateButton
            handler={handleCreateAnouncement}
            buttonText={translate("web:general.createAnnouncement")}
          />
          <SectionHelp
            title={translate("announcements:help.title")}
            intro="Announcements place an important update in front of your church community."
            options={[
              {
                title: "Create an announcement",
                description:
                  "Use an announcement for timely information members should notice, without creating a full event or starting a poll.",
                bestFor:
                  "Schedule changes, ministry updates, urgent notices, celebrations, and church-wide reminders.",
                features: [
                  "Keeps important updates together",
                  "Easy for members to read and revisit",
                  "Works well for concise, actionable communication",
                  "Automatically expires 30 days after it is created",
                ],
              },
            ]}
            footer="Announcements remain available in Praysely for 30 days after creation and are then removed automatically. Put the most important action or deadline near the beginning."
          />
        </TopWrap>
      )}
      {showCreateAnnouncementModal && <CreateAncmtModal />}
      <AnnouncementFeed />
    </ComponentPageWrapper>
  );
}

const TopWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding: 10px;
  gap: 8px;
  justify-content: flex-end;
  svg {
    font-size: 25px;
    color: var(--lightThemeFontColor);
  }
`;
